import { render, staticRenderFns } from "./batchChannelImage.vue?vue&type=template&id=5ec64d58&scoped=true&"
import script from "./batchChannelImage.vue?vue&type=script&lang=js&"
export * from "./batchChannelImage.vue?vue&type=script&lang=js&"
import style0 from "./batchChannelImage.vue?vue&type=style&index=0&id=5ec64d58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec64d58",
  null
  
)

export default component.exports